import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapMenu = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 13.5 13.5",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m13.125 0-.12.023L9 1.575 4.5 0 .27 1.425a.38.38 0 0 0-.27.36v11.34c0 .21.165.375.375.375l.12-.023L4.5 11.926 9 13.5l4.23-1.425a.38.38 0 0 0 .27-.36V.375A.37.37 0 0 0 13.125 0M5.25 1.853l3 1.05v8.745l-3-1.05zm-3.75.742 2.25-.758v8.776l-2.25.87zm10.5 8.31-2.25.758V2.894l2.25-.87z"
	})]
});
const ForwardRef = forwardRef(SvgMapMenu);
export { ForwardRef as ReactComponent };
